export default "__VITE_ASSET__a24a7d6f__"